this.createClient = (name, store, id) => {
    return {
        "name": name,
        "store": store,
        "id": id
    };
};

export default { createClient: this.createClient };


// WEBPACK FOOTER //
// ./src/entities/Client.js